import { useCallback, useEffect, useRef, useState } from 'react'
import { Link,
    //  useLocation
     } from 'react-router-dom'
import './Navbar.css'
import { RiCloseLine, RiMenu3Line } from "react-icons/ri";

const Navbar = () => {
    const [navItems, setNavItems] = useState([
        {id: 1, title: 'Home', link: '/', scroll: '#home', active: true},
        {id: 2, title: 'About', link: '/about', scroll: '#about', active: false},
        {id: 4, title: 'Projects', link: '/projects', scroll: '#projects', active: false},
        {id: 3, title: 'Contact', link: '/contact', scroll: '#contact', active: false},
    ])
    const ref = useRef(null);
    const [open, setOpen] = useState(false);
    // const currentPath = useLocation().pathname
    // console.log(currentPath)
    const nav = useRef(null)

    const closeOpenMenus = useCallback(
      (e) => {
        if (ref.current && open && !ref.current.contains(e.target)) {
          setOpen(false);
        }
      },
      [open]
    );

    useEffect(() => {
      document.addEventListener("mousedown", closeOpenMenus);
      return () => {
        document.removeEventListener("mousedown", closeOpenMenus);
      };
    }, [open]);

    useEffect(() => {
    //   document.body.onscroll = () => {
    //     nav.current.className =
    //       window.scrollY > 0 ? "navbar bg-dark" : "navbar";
    //   };
      window.onscroll = () => {
          nav.current.className =
            window.scrollY > 0 ? "navbar bg-dark" : "navbar";
          window.scrollY > 0
            ? document.querySelector(".ball").classList.add("ballMove")
            : document.querySelector(".ball").classList.remove("ballMove");
        

        document.querySelectorAll(".section").forEach((e) => {
          // console.log(e)
          if (
            window.scrollY >= e.offsetTop - 100 &&
            window.scrollY < e.offsetTop + e.offsetHeight - 100
          ) {
            setNavItems(
              navItems.map((item) => {
                // console.log(item)
                if (item.scroll === `#${e.id}`)
                  return { ...item, active: true };
                else return { ...item, active: false };
              })
            );
          }
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.scrollY])

    const handleItem = (element) => {
        setNavItems(
          navItems.map((item) => {
            if (item.id === element.id) return {...item, active: true};
            else return {...item, active: false};
          })
        );
        setOpen(false);
    }

  return (
    <div className="navbar" ref={nav}>
      <div className="left">
        <h2 className="logo">
          <Link href="/">Ahmed</Link>
        </h2>
      </div>
      <div className="right">
        {navItems.map((item) => {
          return (
            <div className="nav-item" key={item.id}>
              <a href={item.scroll} onClick={() => handleItem(item)}>
                {item.title}
              </a>
              <div
                className={item.active ? "item-activee" : "item-active"}
              ></div>
            </div>
          );
        })}
      </div>
      <div className="menu-mobile">
        {open ? (
          <div className="close-icon">
            <RiCloseLine
              color="#fff"
              size={27}
              style={{ cursor: "pointer" }}
              onClick={() => setOpen(false)}
              // ref={ref}
            />
          </div>
        ) : (
          <div className="menu-icon">
            <RiMenu3Line
              color="#fff"
              size={27}
              style={{ cursor: "pointer" }}
              onClick={() => setOpen(true)}
              // ref={ref}
            />
          </div>
        )}
        {open && <div className="mobile-menu bg-dark" ref={ref}>
          {navItems.map((item) => {
            return (
              <div className="nav-item" key={item.id}>
                <a href={item.scroll} onClick={() => handleItem(item)}>
                  {item.title}
                </a>
                <div
                  className={item.active ? "item-activee" : "item-active"}
                ></div>
              </div>
            );
          })}
        </div>}
      </div>
    </div>
  );
}

export default Navbar